import React from 'react'
import ListCustomerTableItem from "./ListCustomerTableItem"

function ListCustomerTableBody(props) {
    const {error, listCustomers, arrSelected, onSelected} = props

    return (
        <tbody className="TableBody">
        {
            !!listCustomers && listCustomers.length > 0 ? listCustomers.map((item, index) => (
                <ListCustomerTableItem key={index} item={item} arrSelected={arrSelected}
                                       onSelected={onSelected}/>
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào</td>
            </tr>
        }
        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default ListCustomerTableBody
